
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['rendered', 'project_id', 'isAdd'],
  data() {
    return {
      canClick: true,
      isUploading: false
    }
  },
  computed: {
    ...mapGetters(['vip']),
    ...mapState("app", ["project_loading"]),
  },
  created() {       
  },
  methods: {
    async btnClick() { 
      if (!this.canClick) {
          return; // 阻止重复点击
      }

      this.canClick = false;
      setTimeout(() => {
          this.canClick = true;
      }, 1500);
      if (!this.vip || this.vip.status != 'active') {  
         $('#updrage').click()      
         $('#doNotProjectReportPanelBtn').click()
         return false
      }
      if (this.project_loading) {
        return this.$toasted.show('报告未下载完毕，请耐心等待', {position: "top-center", duration: 500})
      }      
      if (this.isAdd) {
        this.$emit('exportingPDF', true)        
      }  
      if (this.project_id) {
        this.$store.commit('app/SET_PROJECT_ID', this.project_id)   
        this.$store.commit('app/SET_PROJECT_LOADING', true)     
        $('#doReportProjectBtn').click()
      }
         
    },
  }
}
